import { useMemo } from 'react';
import { QUERY_KEYS } from 'constants/queryKeys';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { tradeTicketsServices } from 'services/tradeTickets';
import {
  TRADE_TICKETS_EXPORT_LIMIT,
  TRADE_TICKETS_PAGE_SIZE,
} from 'components/tradeTickets/constants';

import { useAssignees } from 'hooks/common';
import {
  getTradeTicketsColumns,
  handleTradeTicketsData,
  getParamsAndPayloadTradeTickets,
} from './utils';

export const useTradeTickets = () => {
  const router = useRouter();
  const {
    assignees,
    isFetching: isAssigneesFetching,
    getAssigneeName,
  } = useAssignees();
  const page = router.query?.page || 1;
  const pageSize = router.query?.pageSize || TRADE_TICKETS_PAGE_SIZE;
  const query = router.query?.query || '';
  const stage = router.query?.stage;
  const contractPeriod = router.query?.contractPeriod;
  const dateFrom = router.query?.dateFrom;
  const dateTo = router.query?.dateTo;
  const orderBy = router.query?.orderBy;
  const order = router.query?.order;
  const hasRequiredFiles = router.query?.hasRequiredFiles;
  const assignee = router.query?.assignee;

  const { cleanedParams, queryParams, payload } = useMemo(
    () =>
      getParamsAndPayloadTradeTickets({
        page,
        pageSize: parseInt(pageSize, 10) || TRADE_TICKETS_PAGE_SIZE,
        query,
        stage,
        contractPeriod,
        dateFrom,
        dateTo,
        orderBy,
        order,
        hasRequiredFiles,
        assignee,
      }),
    [
      page,
      pageSize,
      query,
      stage,
      contractPeriod,
      dateFrom,
      dateTo,
      orderBy,
      order,
      hasRequiredFiles,
      assignee,
    ]
  );

  const tradeTicketsResponse = useQuery(
    [QUERY_KEYS.GET_TRADE_TICKETS_KEY, queryParams, payload],
    () => {
      return tradeTicketsServices.getTradeTickets(queryParams, payload);
    },
    { enabled: router.isReady }
  );

  const tradeTickets = handleTradeTicketsData(
    tradeTicketsResponse?.data?.data || [],
    assignees,
    getAssigneeName
  );

  const columns = getTradeTicketsColumns(tradeTickets);

  const getContractsExportPayload = () => {
    return {
      params: {
        ...cleanedParams,
        page: 1,
        pageSize: TRADE_TICKETS_EXPORT_LIMIT,
      },
      payload: {},
    };
  };

  return {
    page,
    total: tradeTicketsResponse?.data?.meta?.total,
    pageSize: parseInt(pageSize, 10) || TRADE_TICKETS_PAGE_SIZE,
    loading: tradeTicketsResponse?.isFetching || isAssigneesFetching,
    tradeTickets,
    columns,
    tradeTicketsQueryParams: queryParams,
    tradeTicketsPayload: payload,
    getTradeTickets: tradeTicketsResponse.refetch,
    getContractsExportPayload,
  };
};
